import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrossReference = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.5 2.25C16.5 1.83579 16.8358 1.5 17.25 1.5H22.75C23.1642 1.5 23.5 1.83579 23.5 2.25V7.75C23.5 8.16421 23.1642 8.5 22.75 8.5C22.3358 8.5 22 8.16421 22 7.75V4.06066L15.7803 10.2803C15.4874 10.5732 15.0126 10.5732 14.7197 10.2803C14.4268 9.98743 14.4268 9.51256 14.7197 9.21967L20.9393 3H17.25C16.8358 3 16.5 2.66421 16.5 2.25Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.25 4C3.11193 4 3 4.11193 3 4.25V16.75C3 16.8881 3.11193 17 3.25 17H5.75C6.16421 17 6.5 17.3358 6.5 17.75V20.9393L10.2197 17.2197C10.3603 17.079 10.5511 17 10.75 17H20.75C20.8881 17 21 16.8881 21 16.75V10.75C21 10.3358 21.3358 10 21.75 10C22.1642 10 22.5 10.3358 22.5 10.75V16.75C22.5 17.7165 21.7165 18.5 20.75 18.5H11.0607L7.48744 22.0732C7.21418 22.3465 6.84356 22.5 6.45711 22.5C5.65237 22.5 5 21.8476 5 21.0429V18.5H3.25C2.2835 18.5 1.5 17.7165 1.5 16.75V4.25C1.5 3.2835 2.2835 2.5 3.25 2.5H14.25C14.6642 2.5 15 2.83579 15 3.25C15 3.66421 14.6642 4 14.25 4H3.25Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgCrossReference;
